export default __webpack_public_path__ + "static/linkBg6-bb66e9c404b2ecb57eb152b4e430f124.png";